module.exports = __webpack_public_path__ + "static/media/error-404.3ef9f366.svg";